module.exports = __webpack_public_path__ + "static/media/33-giftige.dfb62bdc.mp3";